export default __webpack_public_path__ + "static/excess_insurance_3-124d7551f88f659acab8ee7fcc450ac9.webp";